import { storyblokEditable } from "@storyblok/react";

const BrandsHeaderHacker = ({ blok }) => (
  <div className="wrap">
    <div
      className="brandsheaderhacker-wrap inner-wrap flex items-center"
      {...storyblokEditable(blok)}
    >
      <div className="brandsheaderhacker-wrap-content flex">
        <div className="brandsheaderhacker-left">
          {/*     <img src={blok.logo.filename} alt={blok.logo.alt} /> */}
          <div className="brandsheaderhacker-img-box">
          <img
              className="brandsheaderhacker-logo hide-mobile"
              src={blok.logo.filename}
              alt={blok.logo.alt}
            />
             <img
            className="brandsheaderhacker-logo hide-desktop"
            src={blok.logo.filename}
            alt={blok.logo.alt}
          />
          </div>
      
          <h2 className="brandsheaderhacker-branding text-2xl">
            {blok.slogan}
          </h2>
          <div>
            <img
              className="brandsheaderhacker-mobileimg hide-mobile"
              src={blok.image.filename}
              alt={blok.image.alt}
            />
          </div>

         {blok.infotext && (<p className="brandsheaderhacker-infotext pb-3">{blok.infotext}</p>)} 
         {blok.infotext2 && (<p className="brandsheaderhacker-infotext pb-3">{blok.infotext2}</p>)} 
         {blok.infotext3 && (<p className="brandsheaderhacker-infotext pb-3">{blok.infotext3}</p>)} 
         {blok.infotext4 && (<p className="brandsheaderhacker-infotext pb-3">{blok.infotext4}</p>)} 
         {blok.infotext5 && (<p className="brandsheaderhacker-infotext">{blok.infotext5}</p>)} 

        </div>
        <div className="brandsheaderhacker-right ml-16">
         

          <img
            className="hide-desktop brandsheaderhacker-rightimage"
            src={blok.image.filename}
            alt={blok.image.alt}
          />
        </div>
      </div>
    </div>
  </div>
);
export default BrandsHeaderHacker;
